import { create } from 'zustand';

export const useChatStore = create((set, get) => {
  return {
  // Chat messages
  chatMessages: [],
  setChatMessages: (messages) => set({ chatMessages: messages }),
  addChatMessage: (message) => set((state) => ({ 
    chatMessages: [...state.chatMessages, message] 
  })),
  clearChatMessages: () => set({ chatMessages: [] }),
  
  // Chat input
  inputValue: '',
  setInputValue: (value) => set({ inputValue: value }),
  
  // Loading state
  isLoading: false,
  setIsLoading: (value) => set({ isLoading: value }),
  
  // Conversation
  currentConversationId: null,
  setCurrentConversationId: (id) => set({ currentConversationId: id }),
  
  // Internal flags
  hasProcessedInitialState: false,
  setHasProcessedInitialState: (value) => set({ hasProcessedInitialState: value }),
  
  hasAutoSelectedFirstChat: false,
  setHasAutoSelectedFirstChat: (value) => set({ hasAutoSelectedFirstChat: value }),
  
  // Expose get function for accessing current state
  getChatMessages: () => get().chatMessages,
  };
});

